import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { runOnJS, useAnimatedStyle, useDerivedValue } from 'react-native-reanimated';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import Text, { styles as textStyles } from 'design-system/Text';
import { formatPlural } from 'utils';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
// The tooltip's free side. 'auto' on every platform: Reanimated 4 keeps a
// value it set earlier when the next style leaves it undefined, so the box
// stayed pinned on both sides after the cursor crossed the middle.
const defaultLeftAndRight = 'auto';
const extraPadding = rem(8);
const SelectedBuySellInfoView = ({ width, pointsToShow, selectedInfoObj }) => {
    const styles = useStyles(styleSheet);
    const [info, setInfo] = React.useState(undefined);
    const pointToShow = useDerivedValue(() => {
        if (selectedInfoObj.value?.timeStampRaw) {
            const point = pointsToShow.find((point) => point.pointTimeStamp === selectedInfoObj.value?.timeStampRaw);
            runOnJS(setInfo)(point);
            return point;
        }
        return undefined;
    }, [selectedInfoObj, pointsToShow]);
    const animatedStyles = useAnimatedStyle(() => {
        if (!pointToShow.value) {
            return {
                left: -500,
                right: defaultLeftAndRight,
            };
        }
        const { x } = pointToShow.value;
        if (x > 0.55) {
            return {
                left: defaultLeftAndRight,
                right: width - x * width + extraPadding,
            };
        }
        return {
            right: defaultLeftAndRight,
            left: x * width + extraPadding,
        };
    }, [pointToShow, width]);
    return (<Animated.View style={styles.container} pointerEvents="none">
      <Animated.View style={[styles.flex, animatedStyles]}>
        <View style={styles.outerContainer}>
          {!!info?.buyCount && (<View>
              <Text TextThin-12>
                {info.buyCount} Buy {formatPlural('order', 'orders', info.buyCount)}:
              </Text>
              {info?.buy.map((eachBuy, index) => (<Text TextThin-12 Secondary key={index}>
                  {eachBuy.tradeInfoDesc}
                </Text>))}
            </View>)}
          {!!info?.buyCount && !!info?.sellCount && <Spacer h={2}/>}
          {!!info?.sellCount && (<View>
              <Text TextThin-12>
                {info.sellCount} Sell {formatPlural('order', 'orders', info.sellCount)}:
              </Text>
              {info?.sell.map((eachBuy, index) => (<Text TextThin-12 Secondary key={index}>
                  {eachBuy.tradeInfoDesc}
                </Text>))}
            </View>)}
        </View>
      </Animated.View>
    </Animated.View>);
};
export default React.memo(SelectedBuySellInfoView);
const styleSheet = createStyleSheets((colors) => ({
    container: {
        ...StyleSheet.absoluteFillObject,
        flexDirection: 'row',
    },
    priceContainer: {
        alignItems: 'flex-end',
    },
    flex: {
        top: 0,
        bottom: 0,
        position: 'absolute',
        justifyContent: 'center',
    },
    priceStyles: {
        ...textStyles.NumbersThin_12,
        margin: 0,
        padding: 0,
        height: rem(18),
        color: colors.text.primary,
    },
    outerContainer: {
        borderRadius: rem(8),
        paddingVertical: rem(10),
        paddingHorizontal: rem(10),
        backgroundColor: colors.background.light,
        ...colors.shadows.cardLarge,
    },
}));
